import React, { ReactNode } from 'react'
import { buttonBaseClasses, buttonClasses, SxProps } from '@mui/material'
import { buttonTypesEnum } from './enums/buttonTypesEnum'
import { gecinaBlueMain } from '../../theme'
import MuiButton from '@mui/material/Button'

type ButtonWithIconProps = {
	type?: Extract<buttonTypesEnum, buttonTypesEnum.button | buttonTypesEnum.reset | buttonTypesEnum.submit>
	bgcolor: string
	color: string
	border?: boolean
	onClick?: () => void
	disabled?: boolean
	sx?: SxProps
	startIcon?: ReactNode
}

const ButtonWithIcon: React.FC<ButtonWithIconProps> = (
	{
		children,
		type = buttonTypesEnum.button,
		bgcolor = 'transparent',
		color = gecinaBlueMain,
		border = true,
		onClick,
		disabled = false,
		sx,
		startIcon
	}) => (
	<MuiButton
		sx={[
			{
				textTransform: 'none',
				border: border ? `1px solid ${color}` : 'none',
				bgcolor: bgcolor,
				color: color,
				opacity: disabled ? '0.65' : 1,
				[`&.${buttonBaseClasses.root}`]: {
					'&:hover': {
						bgcolor: bgcolor
					},
					padding: '11px 22px 11px 23px',
					[`.${buttonClasses.startIcon}`]: {
						marginRight: '15px',
						'& svg': {
							width: '19px',
							height: '19px'
						}
					}
				}
			},
			...(Array.isArray(sx) ? sx : [sx])
		]}
		disableElevation
		disableRipple
		type={type}
		onClick={onClick}
		disabled={disabled}
		startIcon={startIcon}
	>
		{children}
	</MuiButton>
)

export default ButtonWithIcon
